    /**
     * Время на складе
     */
    if( $('.js-time').length > 0 ) {

        let current_time = $('.js-time').text().split(':');
        let hours = parseInt(current_time[0]);
        let minutes = parseInt(current_time[1]);
        let seconds = parseInt(current_time[2]);

        setInterval(function () {

            seconds++;

            if (seconds >= 60) {

                seconds = 0;
                minutes++;

                if (minutes >= 60) {
                    minutes = 0;
                    hours++;
                }

                if (hours >= 24) {
                    hours = 0;
                }

            }

            let timeString = pad(hours) + ":" + pad(minutes) + ":" + pad(seconds);
            $(".js-time").text(timeString);

        }, 995);

        function pad(number) {
            return (number < 10 ? '0' : '') + number;
        }

    }